/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1DocumentObjectString } from '../../entities/v1/DocumentObjectString'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1DocumentObjectStringSchema = z.enum([
  'text',
  'img_camera',
  'date',
  'email',
  'text_digit',
  'img_gallery',
  'dropdown_list',
  'pdf',
  'unknown',
]) as unknown as ToZod<V1DocumentObjectString>